// extracted by mini-css-extract-plugin
export default {"wrapper":"PopUpError_wrapper__bxO8J","content":"PopUpError_content__ERbfb","text":"PopUpError_text__jvz0K","textSecondary":"PopUpError_textSecondary__Q0Doo"};